import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function PolitiqueConfidentialitePage() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="legal-back">
          <ArrowLeft size={16} /> Retour à l'accueil
        </Link>

        <h1 className="legal-title">Politique de confidentialité</h1>
        <p className="legal-updated">Dernière mise à jour : mars 2026</p>

        <section className="legal-section">
          <h2>1. Responsable du traitement</h2>
          <p>
            Le responsable du traitement des données personnelles collectées via LoL Arena est
            l'éditeur du site. Pour toute question relative à vos données :{' '}
            <a href="mailto:contact@lol-arena.fr">contact@lol-arena.fr</a>
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Données collectées</h2>
          <p>Lors de votre utilisation de LoL Arena, nous collectons les données suivantes :</p>
          <ul>
            <li>
              <strong>Via l'API Riot Games</strong> : nom d'invocateur, tag Riot (ex. #EUW), région,
              niveau de compte, icône de profil. Ces données sont récupérées uniquement avec votre
              consentement lors de la connexion avec votre compte Riot.
            </li>
            <li>
              <strong>Via Discord (OAuth2)</strong> : nom d'utilisateur Discord, identifiant unique
              Discord, avatar. Ces données sont récupérées uniquement lors de la connexion via votre
              compte Discord et avec votre consentement explicite.
            </li>
            <li>
              <strong>Données de navigation</strong> : adresse IP, type de navigateur, pages visitées,
              horodatage des connexions.
            </li>
            <li>
              <strong>Données de jeu</strong> : historique des tournois participés, résultats des
              matchs, appartenance aux équipes.
            </li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>3. Finalités du traitement</h2>
          <p>Vos données sont utilisées pour :</p>
          <ul>
            <li>Créer et gérer votre compte joueur</li>
            <li>Afficher votre profil et statistiques sur la plateforme</li>
            <li>Organiser et gérer les tournois et équipes</li>
            <li>Assurer la sécurité et prévenir les fraudes</li>
            <li>Améliorer le service (analyse anonymisée de l'usage)</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>4. Base légale</h2>
          <p>
            Le traitement de vos données repose sur votre <strong>consentement</strong> donné lors
            de la connexion via Riot Games ou via Discord (OAuth2), ainsi que sur
            l'<strong>exécution du contrat</strong>{' '}(les CGU) vous liant à LoL Arena.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Durée de conservation</h2>
          <p>
            Vos données sont conservées pendant toute la durée d'activité de votre compte. En cas
            de suppression de compte, les données sont effacées dans un délai de <strong>30 jours</strong>,
            à l'exception des données nécessaires au respect d'obligations légales.
          </p>
        </section>

        <section className="legal-section">
          <h2>6. Partage des données</h2>
          <p>
            Vos données ne sont pas vendues ni cédées à des tiers. Elles peuvent être partagées avec :
          </p>
          <ul>
            <li>
              <strong>Supabase</strong> (hébergement base de données, Supabase Inc., USA) dans le
              cadre du Cloud Supabase, conforme au RGPD via les clauses contractuelles types.
            </li>
            <li>
              <strong>Riot Games</strong> pour la vérification des données de compte, conformément
              à leur politique de confidentialité.
            </li>
            <li>
              <strong>Discord Inc.</strong> pour l'authentification OAuth2, conformément à la{' '}
              <a href="https://discord.com/privacy" target="_blank" rel="noopener noreferrer">
                politique de confidentialité de Discord
              </a>.
            </li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>7. Vos droits (RGPD)</h2>
          <p>Conformément au Règlement Général sur la Protection des Données, vous disposez des droits suivants :</p>
          <ul>
            <li><strong>Droit d'accès</strong> : obtenir une copie de vos données</li>
            <li><strong>Droit de rectification</strong> : corriger des données inexactes</li>
            <li><strong>Droit à l'effacement</strong> : demander la suppression de votre compte</li>
            <li><strong>Droit à la portabilité</strong> : recevoir vos données dans un format lisible</li>
            <li><strong>Droit d'opposition</strong> : vous opposer à certains traitements</li>
          </ul>
          <p>
            Pour exercer ces droits, contactez-nous à{' '}
            <a href="mailto:contact@lol-arena.fr">contact@lol-arena.fr</a>.
            Vous avez également le droit d'introduire une réclamation auprès de la{' '}
            <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">CNIL</a>.
          </p>
        </section>

        <section className="legal-section">
          <h2>8. Cookies</h2>
          <p>
            LoL Arena utilise uniquement des cookies techniques essentiels au fonctionnement du
            service (session d'authentification JWT). Aucun cookie publicitaire ou de tracking
            tiers n'est utilisé.
          </p>
        </section>
      </div>
    </div>
  );
}
